/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

const useAdjustFieldPopup = ({
	showPopup, $containerRef, enabled = true
}) => {
	useEffect(() => {
        if (!enabled) return;
        const $elementsWithScroll = [
            window,
            ...document.querySelectorAll(".custom-scrollbar")
        ];
        window.addEventListener("resize", adjustOptionsBlockPosition);
        $elementsWithScroll.forEach($element => {
            $element.addEventListener("scroll", adjustOptionsBlockPosition);
        });
        return () => {
            window.removeEventListener("resize", adjustOptionsBlockPosition);
            $elementsWithScroll.forEach($element => {
                $element.removeEventListener("scroll", adjustOptionsBlockPosition);
            });
        };
    }, [enabled]);
	useEffect(() => {
        if (!enabled) return;
        adjustOptionsBlockPosition();
    }, [enabled, showPopup, $containerRef.current]);
	function adjustOptionsBlockPosition() {
        if (!$containerRef.current) return;
        const $container = $containerRef.current;
        const $optionsBlock = $container.querySelector(".options-block");
        if (!$optionsBlock) return;
        const $containerRect = $container.getBoundingClientRect();
        $optionsBlock.style.left = `${$containerRect.x}px`;
        $optionsBlock.style.top = `${$containerRect.bottom + 2}px`;
        $optionsBlock.style.width = `${$containerRect.width}px`;
    }
	return {};
}	
	
export default useAdjustFieldPopup;
